<template>
  <div class="currency-setting-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="add-btn" @click="addGroup">+创建参数Group</div>
      <div class="content">
        <div class="item-box" v-for="(box, boxIndex) in 2" :key="boxIndex">
          <div
            class="item"
            v-for="(option, optionIndex) in options"
            v-if="optionIndex % 2 === boxIndex"
            :key="optionIndex"
          >
            <div class="title">
              <div class="input-box" v-if="option.isAdd">
                <input
                  type="text"
                  class="input"
                  placeholder="输入项目名称"
                  v-model="option.title"
                />
              </div>
              <span v-else>{{ option.title }}</span>
            </div>
            <div class="form">
              <div
                class="input-box"
                v-for="(item, index) in option.list"
                :key="index"
              >
                <div class="label" v-if="item.id">
                  {{ item.key }}
                </div>
                <div class="label" v-else>
                  <input
                    type="text"
                    class="input"
                    placeholder="输入项目名称"
                    v-model="item.key"
                  />
                </div>
                <el-select
                  v-model="item.remark"
                  placeholder="请选择"
                  size="small"
                  class="input2"
                  @change="
                    (e) => {
                      changeRemark(e, item);
                    }
                  "
                >
                  <el-option label="值类型" value=""> </el-option>
                  <el-option label="开关类型" value="boolean"> </el-option>
                  <el-option label="日期" value="date"> </el-option>
                  <el-option label="表格" value="table"> </el-option>
                </el-select>
                <div class="item-input">
                  <div v-if="item.remark === 'boolean'">
                    <el-switch
                      active-color="#20BA7C"
                      active-value="1"
                      inactive-value="0"
                      v-model="item.value"
                    >
                    </el-switch>
                  </div>
                  <div v-else-if="item.remark === 'table'"></div>
                  <div v-else-if="item.remark === 'date'">
                    <el-date-picker
                      v-model="item.value"
                      type="date"
                      class="input2"
                      placeholder="选择日期"
                      size="small"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                  <div v-else>
                    <input
                      type="text"
                      class="input"
                      placeholder="数值"
                      v-model="item.value"
                      style="margin-right: 12px"
                    />
                  </div>
                  <!-- <div class="tip">{{ item.unit }}</div> -->
                </div>
                <div class="item-input2">
                  <input
                    v-if="item.remark !== 'boolean'"
                    type="text"
                    class="input"
                    placeholder="数值"
                    v-model="item.unit"
                  />
                </div>
                <div class="delete" @click="handleDelete(item.key, item.group)">
                  <i class="iconfont icon icon-a-rongqi11"></i>
                </div>
                <br />
                <div class="table" v-if="item.remark === 'table'">
                  <div class="btn-box">
                    <div class="btn3" @click="addRow(item)">添加行</div>
                    <div class="btn3 btn4" @click="addCol(item)">添加列</div>
                  </div>
                  <table border cellspacing="12px">
                    <tr>
                      <th>
                        <input
                          type="text"
                          class="input"
                          placeholder="标题"
                          v-if="item.table.length"
                          v-model="item.table[0].title"
                        />
                      </th>
                      <th
                        v-if="
                          item.table.length &&
                            item.table[0] &&
                            item.table[0].cells
                        "
                        v-for="(th, thIndex) in item.table[0].cells"
                        :key="thIndex"
                      >
                        <input
                          type="text"
                          class="input"
                          placeholder="输入列名"
                          style="width: 85px;"
                          v-model="th.key"
                        />
                        <input
                          type="text"
                          class="input"
                          placeholder="填单位"
                          style="width: 56px;"
                          v-model="th.unit"
                        />
                      </th>
                    </tr>
                    <tr v-for="(tr, trIndex) in item.table" :key="trIndex">
                      <td>
                        <input
                          type="text"
                          class="input"
                          placeholder="输入行名"
                          v-model="tr.key"
                        />
                      </td>
                      <td
                        v-if="tr && tr.cells"
                        v-for="(th, thIndex) in tr.cells"
                      >
                        <input
                          type="text"
                          class="input"
                          placeholder="输入数值"
                          v-model="th.value"
                        />
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="btn-box">
              <div class="btn" @click="setOption(option.title)">保存设置</div>
              <div class="btn btn2" @click="addOption(option)">
                + 添加新参数
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'currency-setting',
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '参数配置'
      },
      options: [],
      editOptions: {},
      loading: 0
    };
  },
  mounted() {
    this.getOption();
  },
  computed: {},
  methods: {
    setOption(title) {
      let arr = [];
      let curArr = this.options.find(item => item.title === title);
      // Object.values(this.editOptions).forEach(item => {
      //   if (item.title === title) {
      //     arr.push({
      //       key: item.key,
      //       value: item.value,
      //       group: title,
      //       unit: item.unit,
      //       remark: item.remark
      //     });
      //   }
      // });
      arr = curArr.list.map(item => {
        return {
          key: item.key,
          value: item.value,
          group: title,
          unit: item.unit,
          remark: item.remark,
          table: item.table || []
        }
      })
      console.log(arr);
      console.log(this.options);
      // return;
      this.loading++;
      this.httpPost(this.$root.setConfig, {
        confList: arr
      }).then(
        (res) => {
          this.$message.success('操作成功');
          this.loading--;
          this.getOptionGroup(title);
        },
        (res) => {
          this.$message.error(res);
          this.loading--;
        }
      );
    },
    changeInput(e, item, title) {
      this.editOptions[item.key] = { ...item, value: e.target.value, title };
      console.log(this.editOptions);
    },
    changeSwitch(e, item, title) {
      item.value = e;
      item = { ...item };
      this.editOptions[item.key] = { ...item, value: e, title };
    },
    addGroup(){
      console.log(this.options);
      this.options.push({
        title: '',
        isAdd: true,
        list: []
      })
      // this.loading++;
      // this.httpPost(this.$root.setConfig, {
      //   confList: [
      //     {
      //       group: '123'
      //     }
      //   ]
      // }).then(
      //   (res) => {
      //     this.$message.success('操作成功');
      //     this.loading--;
      //     this.getOptionGroup(title);
      //   },
      //   (res) => {
      //     this.$message.error(res);
      //     this.loading--;
      //   }
      // );
    },
    getOption() {
      this.loading++;
      this.httpGet(this.$root.getCongfigList).then(
        (res) => {
          this.loading--;
          // res = res.map(item => {
          //   return {
          //     ...item,
          //     table: [
          //       {
          //         "title": "V等级", //表格第一列标题
          //         "key": "V1", //表格行键名,
          //         cells: [
          //         {
          //           "key": "比例", //单元格键名
          //           "value": "1", //单元格键值
          //           "unit": "%" //计量单位:元;%;boolean,布尔值,展示开关;
          //           },
          //           {
          //           "key": "贡献值", //单元格键名
          //           "value": "2", //单元格键值
          //           "unit": "个" //计量单位:元;%;boolean,布尔值,展示开关;
          //           }

          //         ]
          //       }
          //     ]
          //   }
          // })
          console.log(res);
          this.options = res;
        },
        (res) => {
          this.$message.error(res);
          this.loading--;
        }
      );
    },
    addRow(item){
      // item.table.push({
      //   title: '',
      //   key: '',
      //   cells: []
      // });
      console.log(item, 123);
      let newRow = {...item.table[0], key: '', cells: item.table[0].cells.map(item => {return {
        ...item,
        value: ''
      }})};
      item.table.push(newRow)
      console.log(this.options);
    },
    addCol(item){
      item.table.forEach(row => {
        row.cells.push({
          key: '',
          value: '',
          unit: ''
        });
      })
    },
    getOptionGroup(title){
      this.loading++;
      this.httpGet(this.$root.getCongfigGroupList, {name: title}).then(
        (res) => {
          this.loading--;
          // this.options = res;
          let obj = {
            title: res.list[0].group,
            list: res.list
          };
          let arr = this.options.map(item => {
            if(item.title === title){
              item = obj;
            };
            return item;
          });
          console.log(this.options);
          this.options = [...arr];
        },
        (res) => {
          this.$message.error(res);
          this.loading--;
        }
      );
    },
    changeRemark(val, item){
      console.log(val);
      if(val === 'table'){
        if(!item.table.length) {
          item.table = [{cells: [], key: '', value: ''}];
        }
      } else {
        item.table = [];
      }
    },
    addOption(option){
      option.list.push({
        key: '',
        value: '',
        group: option.title,
        unit: '',
        remark: '',
        table: [
          {
            title: '',
            key: '',
            cells: []
          }
        ]
      });
      // option.table = [];
      // console.log(this.options);
    },
    handleDelete(key, title){
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除参数吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteConfig, {
          key
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getOptionGroup(title);
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.currency-setting-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    .add-btn{
      // width: 65px;
      confirm-btn();
      height: 32px;
      margin-right: 8px;
      flex-shrink: 0;
      flex-x(center);
      padding: 0 6px;
      margin-left: 24px;
    }

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px;
      border-radius: 2px;
      background: #F6F6F6;
      flex-x(space-between, flex-start);
      flex-wrap: wrap;
      min-width: 1400px;

      .item-box{
        width: 49.5%;  
      }

      .item {
        background: #fff;
        width: 100%;
        padding: 24px;
        box-sizing: border-box;
        overflow: hidden;
        flex-shrink: 1;
        margin-bottom: 12px;
        overflow-x: auto;

        // float: right;
        .title {
          word(20px, #333);
          flex-x();
        }

        .form {
          // padding-left: 80px;
          margin-top: 36px;
        }

          .input-box {
            min-width: 700px;
            min-height: 48px;
            // box
            flex-x(flex-start, flex-start);
            flex-wrap: wrap;

            .label {
              width: 200px;
              height: 32px;
              flex-x();
              // line-height: 32px;
              margin-right: 20px;
              .input{
                width: 100%;
              }
            }

            .input {
              height: 32px;
              width: 150px;
              border: 1px solid #D9D9D9;
              border-radius: 4px;
              padding: 0 12px;
              box-sizing: border-box;
            }
            .input2{
              height: 32px;
              width: 150px;
              margin-right: 15px;
            }
            .table{
              // width: 100%;
              box-sizing: border-box;
              padding: 8px;
              background: #F6F6F6;
              border-radius: 8px;
              margin: 6px 0;
              flex-x();
              .btn-box{
                flex-y(flex-start);
              }
              table{
                margin-left: 12px;
                // background: #F6F6F6;
                padding: 12px 15px;
                td, th{
                  height: 32px;
                  padding: 3px;
                  .input{
                    padding: 0 6px;
                  }
                }
                tr{
                  th: nth-of-type(1){

                  }
                }
              }
            }
          }

          .item-input {
            flex-y(center, flex-end);
            line-height: 32px;
            width: 150px;
            margin-right: 15px;
            .input, .input2{
              width: 100%;
            }
          }

          .item-input2{
            width: 100px;
            margin-right: 15px;
            .input{
              width: 100%;
            }
          }

          .delete{
            width: 32px;
            height: 32px;
            flex-x(center);
            border-radius: 5px;
            background: #F6F6F6;
            cursor: pointer;
            .icon{
              color: #D43030;
            }
          }

          .tip {
            word(12px, #A6A6A6);
            // padding-left: 180px;
            padding-bottom: 3px;
            line-height: 32px;
          }
        }
        .btn-box{
          flex-x(flex-start);
        }
        .btn {
          width: 145px;
          height: 32px;
          confirm-btn();
          flex-x(center);
          margin-top: 32px;
          margin-right: 12px;
        }
        .btn2{
          background: #FFEBEB;
          color: #E33C64;
          border-color: #FFEBEB;
        }

        .btn3{
          width: 75px;
          height: 32px;
          background: #FFEBEB;
          border-radius: 5px;
          border: 1px solid rgba(212, 48, 48, 0.44);
          box-sizing: border-box;
          flex-x(center);
          word(14, #E6456A);
        }
        .btn4{
          margin-top: 12px;
        }
      // }
    }
  }
}
</style>
